import React, { useEffect } from 'react'
import Box from '../components/box'
import Navbar from '../components/navbar'
import useIsAuthenticated from '../hooks/useIsAuthenticated'
import { Navigate } from 'react-router-dom'
// import Typography from '../components/typography'
import { trackUserIdentify } from '../utils/analytics'
import userCurrentUserId from '../hooks/useCurrentUserId';

interface PageLayoutProps {
  children: React.ReactNode
  authOnly?: boolean
  childrenBackground?: string
  addGutter?: boolean
}

const PageLayout: React.FC<PageLayoutProps> = ({
  authOnly = false,
  children,
  childrenBackground,
  addGutter
}) => {
  const isAuthenticated = useIsAuthenticated()
  const userId = userCurrentUserId();

  useEffect(() => {
    async function trackIdentity (): Promise<void> {
      await trackUserIdentify(userId);
    }
    void trackIdentity()
  }, [userId]);

  if (authOnly && !isAuthenticated) {
    return <Navigate to={`/auth/login?redirect=${window.location.pathname}`} />
  }

  return (
    <Box sx={{
      minHeight: '100%',
      margin: 0
    }}>
      <Box sx={{
        display: 'flex',
        flexFlow: 'column',
        minHeight: '100vh',
        background: '#000000'
      }}>
        <Box sx={{ flex: '0 1 auto' }}>
          <Navbar />
        </Box>
        <Box sx={{
          flex: '1 1 auto',
          background: childrenBackground ?? '#000000',
          backgroundSize: 'cover',
          ...(addGutter && { marginY: 3 })
        }}>
          {children}
        </Box>
        {/* <Box sx={{ flex: '0 1 40px' }}> */}
        {/* <Typography variant='h2'>Footer</Typography> */}
        {/* </Box> */}
      </Box>
    </Box>
  )
}

export default PageLayout
